export default __webpack_public_path__ + "static/media/faq_new.7c31c7cf.svg";